<template>
  <button
    class="cookie-bottom-content-settings-btn"
    @click="$root.$emit('cookies-modal-open')"
  >{{ t('cookies.settings') }}</button>
</template>

<script>
export default {
  name: 'CookieSettingsButton'
}
</script>

<template>
  <button
    class="cookie-bottom-content-settings-btn"
    @click="$root.$emit('cookies-modal-open')"
  >{{ t('cookies.settings') }}</button>
</template>

<script>
export default {
  name: 'CookieSettingsButton'
}
</script>

<style lang="scss" scoped>
.cookie-bottom-content-settings-btn {
  background-color: transparent;
  border: none;
  color: #040404;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  transition: color 0.3s ease;

  &:hover {
    color: #6DC8BF;
  }
}
</style>
